<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2hQ0Bh/tc-custom/9781558616912.jpg?1728353339186" alt="This image is the cover for the book If a Tree Falls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If a Tree Falls
      </h1>
      <p class="bookDescription body article font2">
        <b>A revealing memoir of a family and a “wrenching journey into deafness from the standpoint of a mother, a wife, a daughter, a philosopher, and a Jew” (Ilan Stavans, author of <i>On Borrowed Words: A Memoir of Language</i>).</b><br/>  <br/> When her daughters were born deaf, Jennifer Rosner was stunned. Then she discovered a hidden history of deafness in her family, going back generations to the Jewish enclaves of Eastern Europe. Traveling back in time in her mind, she imagined her silent relatives, who showed surprising creativity in dealing with a world that preferred to ignore them.<br/>  <br/> Here, in a “gentle meditation on sound and silence, love and family” Rosner shares her journey into the modern world of deafness, and the controversial decisions she and her husband made about hearing aids, cochlear implants and sign language (<i>Publishers Weekly</i>).<br/>  <br/> Punctuated by memories of being unheard, Rosner’s imaginative odyssey of dealing with her daughters’ deafness is at its heart a story of whether she—a mother with perfect hearing—can ever truly hear her children.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Rosner
      </h2>
      
      <p class="authorDescription body article"><B>Jennifer Rosner</B> is the author of the children's book, <I>The Mitten String</I>, and the editor of the collection <I>The Messy Self</I>. Her work has appeared in <I>The Massachusetts Review</I>, <I>Wondertime Magazine</I>, and the <I>Hastings Center Report</I>. She holds a PhD in philosophy from Stanford University, and currently lives in Massachusetts with her family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Perseus
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3354fb89